import { useState, useEffect } from 'react';
import { API } from 'aws-amplify';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { getMifiel_ProfileInv } from 'src/graphql/customized_queries';
import { Contracts, EachContract } from './contractInfo.styles';

export default function ContractsInfo({ mifielInformation }) {
  const [signed, setSigned] = useState({});
  const user = useSelector((state) => state.user.currentUser);
  const navigate = useNavigate();
  const dataGeneral = mifielInformation?.dataGeneral?.getMifiel;
  const dataRisks = mifielInformation?.dataRisks?.getMifiel;
  const widgetIdGeneral = dataGeneral?.signers?.[0]?.widget_id;
  const widgetIdRisks = dataRisks?.signers?.[0]?.widget_id;

  const createHandleSign = (widgetId) => () => {
    navigate('/inversionista/dashboard/miFiel', { state: { widgetId } });
  };

  const handleSignGeneral = createHandleSign(widgetIdGeneral);
  const handleSignRisks = createHandleSign(widgetIdRisks);

  return (
    <Contracts>
      <div>
        <h3>
          En esta sección encontrarás los contratos que debes firmar o has firmado con Finsphera
        </h3>
        <EachContract>
          <p>{dataGeneral && dataGeneral?.name ? dataGeneral?.name : '-'}</p>
          <p>
            <a
              href={`https://finsphera-webapp-resources.s3.amazonaws.com/${user.id}_invConCom.pdf`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Comisión de Inversionista
            </a>
          </p>
          {!dataGeneral?.signed ? (
            <button onClick={handleSignGeneral}>Firmar</button>
          ) : (
            <>
              <p>Fecha de firma:</p>
              <p>{dataGeneral.signed_at ? dataGeneral.signed_at : '-'}</p>
            </>
          )}
        </EachContract>
        <EachContract>
          <p>{dataRisks && dataRisks.name ? dataRisks.name : '-'}</p>
          <p>
            <a
              href={`https://finsphera-webapp-resources.s3.amazonaws.com/${user.id}_evidenceOfRisks.pdf`}
              target="_blank"
              rel="noopener noreferrer"
            >
              Contrato de riesgos
            </a>
          </p>
          {!dataRisks?.signed ? (
            <button onClick={handleSignRisks}>Firmar</button>
          ) : (
            <>
              <p>Fecha de firma:</p>
              <p>{dataRisks.signed_at ? dataGeneral.signed_at : '-'}</p>
            </>
          )}
        </EachContract>
      </div>
    </Contracts>
  );
}
